<template>
  <div>
    <va-card>
      <div>
        <slot name="tablename" />
      </div>

      <va-data-table
        :fields="fields"
        :data="locations"
        class="va-table va-table--hoverable va-table--clickable"
        api-mode
        no-data-label="Пусто"
      >
        <template slot="id" slot-scope="props">
          <span>{{ props.rowData.id }}</span>
        </template>
        <template slot="address" slot-scope="props">
          <span>{{ props.rowData.address }}</span>
        </template>
        <template slot="phonenumber" slot-scope="props">
          <span>{{
            props.rowData.contacts?.phone || props.rowData.phone
          }}</span>
        </template>
        <template slot="schedule" slot-scope="props">
          <span>{{ props.rowData.schedule || "—" }}</span>
        </template>
        <template slot="show_on_contacts" slot-scope="props">
          <span>{{ props.rowData.show_on_contacts ? "Да" : "Нет" }}</span>
        </template>
        <template slot="show_on_pickup" slot-scope="props">
          <span>{{ props.rowData.show_on_pickup ? "Да" : "Нет" }}</span>
        </template>
        <template slot="is_active" slot-scope="props">
          <span>{{ props.rowData.is_active ? "Да" : "Нет" }}</span>
        </template>
        <template slot="actions" slot-scope="props">
          <va-button
            @click="update(props.rowData)"
            flat
            small
            color="gray"
            icon="fa fa-pencil"
          />
          <va-button
            @click="remove(props.rowData.id)"
            flat
            small
            color="gray"
            icon="fa fa-trash"
          />
        </template>
      </va-data-table>
    </va-card>
    <va-modal v-model="isModalActive" size="large" hide-default-actions>
      <location-update
        @hide="isModalActive = !isModalActive"
        :location="currLocation"
      ></location-update>
    </va-modal>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapActions } from "vuex";
import locationUpdate from "./location-update.vue";
export default {
  components: { locationUpdate },
  props: {
    locations: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      allLocations: Array.from(this.locations),
      isModalActive: false,
      currLocation: {},
    };
  },
  computed: {
    fields() {
      return [
        {
          name: "__slot:id",
          title: "Номер",
        },
        {
          name: "__slot:address",
          title: "Адрес",
        },
        {
          name: "__slot:phonenumber",
          title: "Номер телефона",
        },
        {
          name: "__slot:schedule",
          title: "Расписание",
        },
        {
          name: "__slot:show_on_contacts",
          title: "В контактах",
        },
        {
          name: "__slot:show_on_pickup",
          title: "Самовывоз",
        },
        {
          name: "__slot:is_active",
          title: "Активен",
        },
        {
          name: "__slot:actions",
          title: "",
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetchLocations: "locations/getLocations",
    }),
    update(location) {
      this.isModalActive = !this.isModalActive;
      this.currLocation = location;
    },
    async remove(locationId) {
      try {
        if (confirm("Вы действительно хотите удалить ?")) {
          await api.delete(`/admin/locations/${locationId}`);
          await this.fetchLocations();
        }
      } catch (error) {
        return error;
      }
    },
  },
};
</script>
